import { HiOutlineArrowDownTray } from 'react-icons/hi2';

import { Timestamp } from '@/components/date-time';
import { TableEmptyPlaceholder } from '@/components/loading';
import { Button } from '@/components-new/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components-new/table';
import { Attachment } from '@/types/attachment';

type AttachmentsTableProps = {
  attachments: Attachment[];
  onDownloadHandler: (url: string) => void;
};

export const AttachmentsTable = ({ attachments, onDownloadHandler }: AttachmentsTableProps) => {
  if (attachments.length === 0) {
    return <TableEmptyPlaceholder content="No attachments have been added."/>;
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeader>File Name</TableHeader>
          <TableHeader>Created At</TableHeader>
          <TableHeader></TableHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        {attachments.map((attachment) => (
          <TableRow key={attachment.id}>
            <TableCell>{attachment.filename}</TableCell>
            <TableCell><Timestamp value={attachment.createdAt}/></TableCell>
            <TableCell>
              <Button
                plain
                title="Download"
                onClick={() => onDownloadHandler(attachment.url)}
                aria-label="Download"
              >
                <HiOutlineArrowDownTray/>
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
